/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { headerSearch } from "helpers/util-common";
import MemberMobileMenu from "./MemberMobileMenu";
import { useLocation } from "react-router-dom";
import { MemberAppNavUrls } from "models/common.models";
import { Header, WCMSElement } from "@astmpkg/common-functions";
import { handleLoggedIn } from "helpers/OktaUtility";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { LogOutAction } from "common.actions";

const AppHeader = (props) => {
  const { userInfo } = props;
  const { entitlementInfo } = useSelector((state) => state.commonReducer);
  const dispatch = useDispatch();
  const [isAppUrl, setIsAppUrl] = useState(false);
  const location = useLocation();
  const myAppsPath = MemberAppNavUrls;

  useEffect(() => {
    const matchFound = myAppsPath.some(
      (item) => item.toLowerCase() === location.pathname.toLowerCase()
    );
    if (matchFound) {
      setIsAppUrl(true);
    }
  }, [location]);

  return (
    <header data-testid="headertest">
      <div className="container">
        <Header
          loginHandler={() => handleLoggedIn("")}
          userInfo={userInfo}
          logoutHandler={() => LogOutAction(dispatch)}
          demoGraphy={entitlementInfo?.otherInfo?.demographyDetails}
          entitlementList={entitlementInfo}
          searchHandler={headerSearch}
          publicUrl={process.env.REACT_APP_PUB_URL}
          menuUrls={{
            profile: process.env.REACT_APP_GLOBAL_PROFILE_URL,
            membership: process.env.REACT_APP_GLOBAL_MYASTM_URL,
            myCommittees: process.env.REACT_APP_GLOBAL_MYCOMMITTEE_URL,
            compass: process.env.REACT_APP_GLOBAL_COMPASS_URL,
            orders: process.env.REACT_APP_GLOBAL_ORDERS_URL,
            tracker: process.env.REACT_APP_GLOBAL_TRACKERS_URL,
            elearning: process.env.REACT_APP_E_LEARNING_URL,
            specbuilder:
              process.env.REACT_APP_IS_SPB_ENABLED === "true"
                ? process.env.REACT_APP_SPECBUILDER_URL
                : "",
            meetingsSymposia: process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL,
          }}
        />
        {isAppUrl && <MemberMobileMenu />}
      </div>
      <WCMSElement
        path={process.env.REACT_APP_WCMS_AWS_HEADER_PATH}
        css={process.env.REACT_APP_WCMS_AWS_CSS_PATH}
      />
    </header>
  );
};

export default AppHeader;
